
import { useState } from 'react';
import Logo from '../../components/base/Logo';
import SEOHead from '../../components/SEOHead';

const BlogPage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Blog",
    "name": "SEO Блог",
    "description": "Экспертные статьи, практические советы и актуальные тренды в мире поискового продвижения",
    "url": `${siteUrl}/blog`,
    "publisher": {
      "@type": "Organization",
      "name": "SEO Vektor",
      "url": siteUrl
    },
    "blogPost": [
      {
        "@type": "BlogPosting",
        "headline": "Как правильно анализировать SEO метрики в 2024 году",
        "description": "Разбираем основные показатели эффективности SEO продвижения и учимся правильно интерпретировать данные аналитики.",
        "datePublished": "2024-12-15",
        "author": {
          "@type": "Organization",
          "name": "SEO Vektor"
        }
      },
      {
        "@type": "BlogPosting",
        "headline": "10 секретов создания SEO-контента, который продает",
        "description": "Практические советы по написанию текстов, которые одновременно нравятся поисковикам и конвертируют посетителей в клиентов.",
        "datePublished": "2024-12-12",
        "author": {
          "@type": "Organization",
          "name": "SEO Vektor"
        }
      }
    ]
  };

  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'Все статьи', count: 24 },
    { id: 'seo', name: 'SEO', count: 8 },
    { id: 'content', name: 'Контент', count: 6 },
    { id: 'technical', name: 'Техническое SEO', count: 5 },
    { id: 'linkbuilding', name: 'Линкбилдинг', count: 3 },
    { id: 'local', name: 'Локальное SEO', count: 2 }
  ];

  const articles = [
    {
      id: 1,
      title: 'Как правильно анализировать SEO метрики в 2024 году',
      excerpt: 'Разбираем основные показатели эффективности SEO продвижения и учимся правильно интерпретировать данные аналитики для принятия стратегических решений.',
      category: 'seo',
      categoryName: 'SEO',
      date: '15 декабря 2024',
      readTime: '5 мин',
      image: 'https://readdy.ai/api/search-image?query=SEO%20analytics%20dashboard%20on%20computer%20screen%20showing%20graphs%20charts%20and%20website%20traffic%20data%2C%20modern%20office%20workspace%20with%20coffee%20cup%20and%20notebook%2C%20professional%20digital%20marketing%20atmosphere&width=600&height=300&seq=article1&orientation=landscape',
      featured: true
    },
    {
      id: 2,
      title: '10 секретов создания SEO-контента, который продает',
      excerpt: 'Практические советы по написанию текстов, которые одновременно нравятся поисковикам и конвертируют посетителей в клиентов.',
      category: 'content',
      categoryName: 'Контент',
      date: '12 декабря 2024',
      readTime: '8 мин',
      image: 'https://readdy.ai/api/search-image?query=Content%20marketing%20workspace%20with%20laptop%20showing%20blog%20writing%20interface%2C%20coffee%20cup%2C%20notepad%20with%20SEO%20keywords%2C%20modern%20desk%20setup%20with%20plants%20and%20natural%20lighting&width=600&height=300&seq=article2&orientation=landscape',
      featured: true
    },
    {
      id: 3,
      title: 'Техническая оптимизация сайта: чек-лист на 2024 год',
      excerpt: 'Полный список технических факторов, которые влияют на позиции сайта в поисковых системах.',
      category: 'technical',
      categoryName: 'Техническое SEO',
      date: '10 декабря 2024',
      readTime: '12 мин',
      image: 'https://readdy.ai/api/search-image?query=Technical%20SEO%20optimization%20concept%20with%20website%20code%20on%20screen%2C%20speed%20test%20results%2C%20mobile%20responsive%20design%20elements%2C%20developer%20workspace%20with%20multiple%20monitors&width=600&height=300&seq=article3&orientation=landscape',
      featured: false
    },
    {
      id: 4,
      title: 'Белые методы линкбилдинга: как получать качественные ссылки',
      excerpt: 'Эффективные стратегии наращивания ссылочной массы без риска получить санкции от поисковых систем.',
      category: 'linkbuilding',
      categoryName: 'Линкбилдинг',
      date: '8 декабря 2024',
      readTime: '10 мин',
      image: 'https://readdy.ai/api/search-image?query=Link%20building%20strategy%20visualization%20with%20network%20connections%2C%20backlink%20analysis%20charts%2C%20SEO%20tools%20interface%2C%20professional%20digital%20marketing%20workspace&width=600&height=300&seq=article4&orientation=landscape',
      featured: false
    },
    {
      id: 5,
      title: 'Локальное SEO: как привлечь клиентов из вашего города',
      excerpt: 'Пошаговое руководство по оптимизации сайта для локальных запросов и работе с Google My Business.',
      category: 'local',
      categoryName: 'Локальное SEO',
      date: '5 декабря 2024',
      readTime: '7 мин',
      image: 'https://readdy.ai/api/search-image?query=Local%20SEO%20concept%20with%20map%20pins%2C%20mobile%20phone%20showing%20local%20business%20listings%2C%20GPS%20navigation%2C%20small%20business%20storefront%20in%20background&width=600&height=300&seq=article5&orientation=landscape',
      featured: false
    },
    {
      id: 6,
      title: 'SEO для интернет-магазинов: увеличиваем продажи через поиск',
      excerpt: 'Специфика продвижения интернет-магазинов: от оптимизации карточек товаров до работы с фильтрами.',
      category: 'seo',
      categoryName: 'SEO',
      date: '3 декабря 2024',
      readTime: '15 мин',
      image: 'https://readdy.ai/api/search-image?query=E-commerce%20SEO%20optimization%20with%20online%20store%20interface%2C%20product%20listings%2C%20shopping%20cart%2C%20conversion%20rate%20analytics%2C%20modern%20laptop%20displaying%20sales%20dashboard&width=600&height=300&seq=article6&orientation=landscape',
      featured: false
    },
    {
      id: 7,
      title: 'Семантическое ядро: как собрать и кластеризовать запросы',
      excerpt: 'Подробное руководство по сбору семантического ядра, анализу конкурентов и группировке ключевых слов.',
      category: 'seo',
      categoryName: 'SEO',
      date: '1 декабря 2024',
      readTime: '11 мин',
      image: 'https://readdy.ai/api/search-image?query=Keyword%20research%20process%20with%20spreadsheets%20showing%20search%20volume%20data%2C%20competitor%20analysis%20tools%2C%20SEO%20planning%20workspace%20with%20charts%20and%20graphs&width=600&height=300&seq=article7&orientation=landscape',
      featured: false
    },
    {
      id: 8,
      title: 'Оптимизация скорости загрузки: влияние на SEO и конверсию',
      excerpt: 'Как ускорить сайт и почему это критически важно для поискового продвижения и пользовательского опыта.',
      category: 'technical',
      categoryName: 'Техническое SEO',
      date: '28 ноября 2024',
      readTime: '9 мин',
      image: 'https://readdy.ai/api/search-image?query=Website%20speed%20optimization%20tools%20showing%20page%20load%20time%20metrics%2C%20performance%20analysis%20dashboard%2C%20fast%20loading%20website%20interface%20on%20laptop%20screen&width=600&height=300&seq=article8&orientation=landscape',
      featured: false
    }
  ];

  const filteredArticles = selectedCategory === 'all' 
    ? articles 
    : articles.filter(article => article.category === selectedCategory);

  const featuredArticles = articles.filter(article => article.featured);

  return (
    <>
      <SEOHead
        title="SEO Блог - Экспертные статьи по поисковому продвижению | SEO Vektor"
        description="Экспертные статьи, практические советы и актуальные тренды в мире поискового продвижения. Полезные материалы от профессионалов SEO."
        keywords="SEO блог, статьи по SEO, поисковое продвижение, SEO советы, оптимизация сайтов, контент маркетинг"
        structuredData={structuredData}
      />
      
      <div className="min-h-screen bg-white">
        {/* Header */}
        <header className="bg-white shadow-sm sticky top-0 z-50">
          <div className="container mx-auto px-6 py-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-8">
                <Logo />
                <nav className="hidden md:flex space-x-6">
                  <a href="/#services" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">Услуги</a>
                  <a href="/#tariffs" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">Тарифы</a>
                  <a href="/#cases" className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">Кейсы</a>
                  <a href="/blog" className="text-blue-600 font-semibold cursor-pointer">Блог</a>
                </nav>
              </div>
              <button 
                onClick={() => document.getElementById('consultation-form')?.scrollIntoView({ behavior: 'smooth' })}
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
              >
                Консультация
              </button>
            </div>
          </div>
        </header>

        {/* Hero Section */}
        <section className="py-20 bg-gradient-to-br from-blue-50 to-white">
          <div className="container mx-auto px-6">
            <div className="text-center mb-16">
              <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
                SEO Блог
              </h1>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Экспертные статьи, практические советы и актуальные тренды в мире поискового продвижения
              </p>
            </div>
          </div>
        </section>

        {/* Featured Articles */}
        <section className="py-16 bg-white">
          <div className="container mx-auto px-6">
            <h2 className="text-3xl font-bold text-gray-900 mb-12">Рекомендуемые статьи</h2>
            <div className="grid md:grid-cols-2 gap-8">
              {featuredArticles.map((article) => (
                <article key={article.id} className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow cursor-pointer">
                  <img 
                    src={article.image} 
                    alt={article.title}
                    className="w-full h-64 object-cover object-top"
                  />
                  <div className="p-8">
                    <div className="flex items-center mb-4">
                      <span className="text-sm text-blue-600 bg-blue-100 px-3 py-1 rounded-full">
                        {article.categoryName}
                      </span>
                      <span className="text-sm text-gray-500 ml-4">{article.date}</span>
                      <span className="text-sm text-gray-500 ml-4">{article.readTime} чтения</span>
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-4 hover:text-blue-600 transition-colors">
                      {article.title}
                    </h3>
                    <p className="text-gray-600 mb-6">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center justify-between">
                      <span className="text-blue-600 font-semibold hover:text-blue-700 transition-colors cursor-pointer">
                        Читать далее
                      </span>
                      <i className="ri-arrow-right-line text-blue-600"></i>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* Categories and Articles */}
        <section className="py-16 bg-gray-50">
          <div className="container mx-auto px-6">
            {/* Categories Filter */}
            <div className="flex flex-wrap gap-4 mb-12 justify-center">
              {categories.map((category) => (
                <button
                  key={category.id}
                  onClick={() => setSelectedCategory(category.id)}
                  className={`px-6 py-3 rounded-full font-semibold transition-colors whitespace-nowrap cursor-pointer ${
                    selectedCategory === category.id
                      ? 'bg-blue-600 text-white'
                      : 'bg-white text-gray-700 hover:bg-blue-50 hover:text-blue-600'
                  }`}
                >
                  {category.name} ({category.count})
                </button>
              ))}
            </div>

            {/* Articles Grid */}
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredArticles.map((article) => (
                <article key={article.id} className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow cursor-pointer">
                  <img 
                    src={article.image} 
                    alt={article.title}
                    className="w-full h-48 object-cover object-top"
                  />
                  <div className="p-6">
                    <div className="flex items-center mb-3">
                      <span className="text-xs text-blue-600 bg-blue-100 px-3 py-1 rounded-full">
                        {article.categoryName}
                      </span>
                      <span className="text-xs text-gray-500 ml-3">{article.date}</span>
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 mb-3 hover:text-blue-600 transition-colors">
                      {article.title}
                    </h3>
                    <p className="text-gray-600 text-sm mb-4">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center justify-between">
                      <span className="text-sm text-gray-500">{article.readTime} чтения</span>
                      <i className="ri-arrow-right-line text-blue-600"></i>
                    </div>
                  </div>
                </article>
              ))}
            </div>

            {/* Load More Button */}
            <div className="text-center mt-12">
              <button className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
                Загрузить еще статьи
              </button>
            </div>
          </div>
        </section>

        {/* Newsletter Subscription */}
        <section className="py-16 bg-blue-600">
          <div className="container mx-auto px-6 text-center">
            <h2 className="text-3xl font-bold text-white mb-4">
              Подпишитесь на SEO рассылку
            </h2>
            <p className="text-blue-100 mb-8 max-w-2xl mx-auto">
              Получайте свежие статьи, кейсы и эксклюзивные материалы по поисковому продвижению прямо на почту
            </p>
            <div className="max-w-md mx-auto">
              <div className="flex gap-4">
                <input
                  type="email"
                  placeholder="Ваш email"
                  className="flex-1 px-4 py-3 rounded-lg border-0 focus:ring-2 focus:ring-blue-300 text-sm"
                />
                <button className="bg-white text-blue-600 px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer">
                  Подписаться
                </button>
              </div>
              <p className="text-blue-100 text-xs mt-3">
                Никакого спама. Только полезный контент по SEO.
              </p>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="bg-gray-900 text-white py-12">
          <div className="container mx-auto px-6">
            <div className="grid md:grid-cols-4 gap-8">
              <div>
                <Logo />
                <p className="text-gray-400 mb-4 mt-4">
                  Профессиональное SEO продвижение для вашего бизнеса
                </p>
                <div className="flex space-x-4">
                  <a href="https://t.me/seo_vektor" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                    <i className="ri-telegram-fill text-xl"></i>
                  </a>
                  <a href="https://wa.me/79503603520" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                    <i className="ri-whatsapp-fill text-xl"></i>
                  </a>
                  <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                    <i className="ri-linkedin-fill text-xl"></i>
                  </a>
                </div>
              </div>
              
              <div>
                <h4 className="text-lg font-semibold mb-4">Услуги</h4>
                <ul className="space-y-2">
                  <li><a href="/#services" className="text-gray-400 hover:text-white transition-colors cursor-pointer">SEO Аудит</a></li>
                  <li><a href="/#services" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Техническая оптимизация</a></li>
                  <li><a href="/#services" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Контент-маркетинг</a></li>
                  <li><a href="/#services" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Линкбилдинг</a></li>
                </ul>
              </div>
              
              <div>
                <h4 className="text-lg font-semibold mb-4">Контакты</h4>
                <ul className="space-y-2 text-gray-400">
                  <li>📍 Москва, Россия</li>
                  <li>📞 <a href="tel:+79503603520" className="hover:text-white transition-colors">+7 950 360-35-20</a></li>
                  <li>✉️ <a href="mailto:info@seo-vektor.ru" className="hover:text-white transition-colors">info@seo-vektor.ru</a></li>
                </ul>
              </div>

              <div>
                <h4 className="text-lg font-semibold mb-4">Подписка</h4>
                <p className="text-gray-400 mb-4">Получайте новости и обновления по почте</p>
                <form className="flex flex-col sm:flex-row gap-2">
                  <input type="email" placeholder="Ваш email" className="flex-1 px-4 py-2 rounded-lg bg-gray-800 text-white focus:outline-none text-sm" />
                  <button type="submit" className="px-4 py-2 bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap">Подписаться</button>
                </form>
              </div>
            </div>
            
            <div className="mt-12 pt-8 border-t border-gray-800 text-center">
              <p className="text-gray-400 text-sm">
                © {new Date().getFullYear()} SEO Vektor. Все права защищены. | 
                <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors ml-1">
                  Powered by Readdy
                </a>
              </p>
            </div>
          </div>
        </footer>

      </div>
    </>
  );
};

export default BlogPage;
